"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformGradient = exports.default = void 0;
/**
 * Transforms a gradient object into a CSS gradient string.
 *
 * @param {Object} gradient - The gradient object to transform.
 * @param {string} gradient.type - The type of gradient (linear or radial).
 * @param {number} gradient.angle - The angle of the linear gradient in degrees.
 * @param {Array} gradient.stops - An array of gradient stops.
 * @param {string} gradient.stops[].color - The color of the gradient stop.
 * @param {number} gradient.stops[].stop - The position of the gradient stop as a percentage.
 * @returns {string} The CSS gradient string.
 */
const transformGradient = gradient => `${gradient.type}-gradient(${gradient.angle}deg, ${gradient.stops[0].color} ${gradient.stops[0].stop * 100}%, ${gradient.stops[1].color} ${gradient.stops[1].stop * 100}%)`;
exports.transformGradient = transformGradient;
var _default = exports.default = {
  transformGradient
};